import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class InventoryValuation  {
    _originalTypeClassName = "zERP.BO.InventoryValuation";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
InventoryValuation.translate = translateService;
}
this.Entity = new Domain.BusinessEntity();
this.Years = [];
this.Id = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Entity:any;
Years:any;
static setEntity = ($this, value) => {
var oldValue = $this.Entity;
$this.Entity = value;
if (value != null) {
}
}
static setYears = ($this, items) => {
                if (items == null) items = [];
                if ($this.Years == null) $this.Years = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Years.length > 0) {
                    Domain.InventoryValuation.removeYears($this, $this.Years[0]);
                }

                Domain.InventoryValuation.addManyYears($this, copyItems);
            }
static addManyYears = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.InventoryValuation.addYears($this, items[i]);
                }
            }
static addYears = ($this, item) => {
                if ($this.Years == null) $this.Years = [];
                if (item == null || $this.Years.indexOf(item) > -1) return;
                $this.Years.push(item);
}
static addRangeYears = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.InventoryValuation.addYears($this, item));
            }
static removeYears = ($this, item) => {
                if ($this == null || $this.Years == null || $this.Years.indexOf(item) === -1) return;
                var _index = $this.Years.indexOf(item);
                $this.Years.splice(_index, 1);
}
static clearYears = ($this) => { $this.Years = null; }

static GetValuationMethods(): any{let methods = [];
methods?.add(Domain.ValuationMethod.Average);
methods?.add(Domain.ValuationMethod.LIFO);
methods?.add(Domain.ValuationMethod.FIFO);
return methods;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}